module.exports = __webpack_public_path__ + "static/images/styles/images/in-battle-icon.c21e2603.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/in-battle-icon.png
// module id = 3647
// module chunks = 11